export const getApiBaseUrl = (): string => {
  if (typeof window !== 'undefined' && window.location && window.location.search) {
    const urlParams = new URLSearchParams(window.location.search);
    const bport = urlParams.get('bport');
    if (bport) {
      return `http://localhost:${bport}`;
    }
  }

  // Fallback for SSR or if bport is not present
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
};

export const getApiPort = (): number | null => {
  if (typeof window !== 'undefined' && window.location && window.location.search) {
    const urlParams = new URLSearchParams(window.location.search);
    const bport = urlParams.get('bport');
    if (bport) {
      const port = parseInt(bport, 10);
      return isNaN(port) ? null : port;
    }
  }
  // Fallback for SSR or if bport is not present
  const fallbackUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
  try {
    const url = new URL(fallbackUrl);
    const port = parseInt(url.port, 10);
    return isNaN(port) ? null : port;
  } catch {
    return null;
  }
};


export async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok && response.status !== 207) { // Allow 207 Multi-Status to pass for specific handling
    let errorData;
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      errorData = await response.json();
      if (errorData && errorData.error && errorData.error.message) {
        errorMessage = errorData.error.message;
        if (errorData.error.details) {
          // Can be an array of strings from class-validator
          const details = Array.isArray(errorData.error.details)
            ? errorData.error.details.join('; ')
            : errorData.error.details;
          errorMessage += `: ${details}`;
        }
      } else if (errorData && errorData.message) {
        errorMessage = errorData.message;
      }
    } catch {
      // The response was not JSON. Use statusText or a generic message.
      errorMessage = response.statusText || `HTTP error! status: ${response.status}`;
    }
    console.error('API Error:', response.status, errorData || errorMessage);
    throw new Error(errorMessage);
  }
  // For 204 No Content, response.json() will fail.
  if (response.status === 204) {
    return {} as T;
  }
  return response.json();
}
